import { Box, FormControlLabel, Checkbox as CheckB } from '@mui/material';
import { Check } from '@mui/icons-material';
import dynamicfunction from '../../../../utils/dynamicfunction';
import Text from '../../../../components/Text';
import { cn } from '../../../../utils/utils';
import { COLORS, fontSizes } from '../../../../constants/constants';
import RowView from '../RowView';
import { ReactSVG } from 'react-svg';
import icons from '../../../../constants/icons';

const Checkbox = ({
  value,
  onChange,
  label,
  required = true,
  options,
  keyValue = 'name',
  weight,
  isVertical = false,
  isUploadDocument = false,
  uploadedDocuments,
  onPressDocument,
  onDeleteDocument,
  getContent,
}) => {
  const { isArabic, direction } = dynamicfunction();

  return (
    <div>
      <Text
        text={label}
        size={fontSizes.h16}
        weight={weight}
        isRequired={required}
        className='mb-2 block'
        isTruncate={false}
      />

      <div className={cn('flex', isArabic ? 'flex-row-reverse' : 'flex-row')}>
        <div
          className={cn(
            'flex flex-wrap',
            isVertical ? 'flex-col' : 'flex-row',
            isArabic ? 'items-end' : 'items-start'
          )}
        >
          {options && options?.length > 0 ? (
            options?.map((item) => {
              const isChecked =
                value?.length > 0 &&
                value?.some((v) => v?.valueId === item?.id);
              const documentForOption = uploadedDocuments?.find(
                (doc) => Number(doc?.investmentCriteriaId) === Number(item?.id)
              );
              return (
                <div key={item?.id}>
                  <FormControlLabel
                    key={item?.id}
                    className='w-fit text-primary-dark'
                    labelPlacement={isArabic ? 'start' : 'end'}
                    // fontSize={fontSizes?.h14}
                    sx={{
                      marginRight: isArabic ? -1 : '',
                    }}
                    control={
                      <CheckB
                        checked={
                          value?.length > 0 &&
                          value?.some((v) => v?.valueId === item?.id)
                        }
                        onChange={() => onChange(item)}
                        icon={
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            borderColor={COLORS.grey}
                            borderRadius={1.5}
                            border={1.5}
                            width={20}
                            height={20}
                          />
                        }
                        checkedIcon={
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            borderColor={COLORS.primary}
                            bgcolor={COLORS.primary + 10}
                            borderRadius={1.5}
                            border={1.5}
                            width={20}
                            height={20}
                          >
                            <Check
                              sx={{
                                fontSize: 18,
                                color: COLORS.primary,
                                stroke: 20,
                              }}
                            />
                          </Box>
                        }
                        sx={{
                          '&.Mui-checked': {
                            color: COLORS.primary,
                          },
                        }}
                      />
                    }
                    label={item?.[keyValue]}
                    componentsProps={{
                      typography: {
                        fontSize: fontSizes?.h14,
                      },
                    }}
                  />
                  {isUploadDocument &&
                    isChecked &&
                    (documentForOption ? (
                      <RowView
                        className='ms-7 items-center gap-2'
                        onClick={() => onPressDocument?.(item)}
                      >
                        <ReactSVG src={icons.document_icon} />
                        <Text
                          text={
                            documentForOption?.documentName ??
                            documentForOption?.fileName ??
                            ''
                          }
                        />
                        <ReactSVG
                          src={icons.close_icon}
                          className='cursor-pointer'
                          onClick={(e) => {
                            e?.stopPropagation();
                            onDeleteDocument?.(item);
                          }}
                        />
                      </RowView>
                    ) : (
                      <RowView
                        className='ms-7 items-center gap-2 cursor-pointer'
                        onClick={() => onPressDocument?.(item)}
                      >
                        <Text
                          text={getContent("upload_document")}
                          size={fontSizes.h16}
                          color='text-primary'
                          className='underline'
                        />
                        <Text
                          text={'+'}
                          size={fontSizes.h20}
                          color='text-primary'
                        />
                      </RowView>
                    ))}
                </div>
              );
            })
          ) : (
            <Text text='No Data Available' />
          )}
        </div>
      </div>
    </div>
  );
};

export default Checkbox;
